import { App } from 'vue';

export default {
  install(app: App) {
    
    app.config.globalProperties.$toCurrency = (
      value: any,
      currency: 'MXN' | 'USD' = 'MXN'
    ): string => {
      const numberValue = Number(value);
      if (isNaN(numberValue)) return value;

      return numberValue.toLocaleString(currency === 'USD' ? 'en-US' : 'es-MX', {
        style: 'currency',
        currency
      });
    };

    // Formatea una cadena como "$12,345"
    app.config.globalProperties.$formatCurrency = (rawValue: string): string => {
      const numeric = rawValue.replace(/\D/g, '');
      if (!numeric) return '';
      return '$' + parseFloat(numeric).toLocaleString('en-US');
    };

    // Extrae solo el número desde una cadena tipo "$12,345"
    app.config.globalProperties.$getNumericValue = (currencyStr: string): number => {
      return Number(currencyStr.replace(/[^\d]/g, ''));
    };

  }
};
